interface Props {
  color?: string
  width?: number
  height?: number
}

export const UploadIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.2764 10C20.5523 10.0003 20.7764 10.224 20.7764 10.5V18.2754C20.7764 19.6559 19.6569 20.7751 18.2764 20.7754H2.72461C1.3439 20.7754 0.224609 19.6561 0.224609 18.2754V10.5049C0.224609 10.2287 0.448467 10.0049 0.724609 10.0049C1.00054 10.0051 1.22461 10.2289 1.22461 10.5049V18.2754C1.22461 19.1038 1.89618 19.7754 2.72461 19.7754H18.2764C19.1046 19.7751 19.7764 19.1037 19.7764 18.2754V10.5C19.7764 10.2239 20.0002 10 20.2764 10ZM10.5 2.5C10.6279 2.50008 10.7559 2.54898 10.8535 2.64648L15.7422 7.53418C15.937 7.7293 15.9369 8.04599 15.7422 8.24121C15.547 8.43643 15.2295 8.43635 15.0342 8.24121L10.9961 4.20312V14C10.9961 14.276 10.7721 14.4998 10.4961 14.5C10.22 14.5 9.99609 14.2761 9.99609 14V4.21094L5.96582 8.24121C5.7706 8.43643 5.45406 8.43635 5.25879 8.24121C5.06364 8.04594 5.06357 7.7294 5.25879 7.53418L10.123 2.66895C10.2146 2.56591 10.3474 2.5 10.4961 2.5H10.5Z"
        fill={color}
      />
    </svg>
  )
}
